/**
 * True when a field with `appearsAfterField` must stay hidden because every
 * controlling field is still empty.
 *
 * The engine's built-in evaluator falls back to `orderData` with
 * `!== undefined`, so a saved empty string (`permitNumber_userAccountDetailVulcan: ''`)
 * counts as "answered" and the dependent field (Expiration Date) shows up
 * before anything is typed. The legacy check (`isRelatedFieldExisted`) used a
 * truthy test there; this restores it.
 *
 * @param {Object} field   Field definition (carries `appearsAfterField` entries)
 * @param {Object} values  Live engine values
 * @param {Object} orderData
 * @returns {boolean}
 */
export default function isGatedByEmptyRelatedField(field, values, orderData) {
  const related = (field && field.appearsAfterField) || [];
  return related.some(entry => {
    const name = entry && entry.fields && entry.fields.name;
    if (!name) return false;
    return !(values && values[name]) && !(orderData && orderData[name]);
  });
}
